module.exports = __webpack_public_path__ + "img/lose.865e93c2.jpg";